import { importChunk } from 'root/utils/importChunk/importChunk';
const chunkMapLoop = (map, chunk) => {
    map.forEach(group => {
        for (let [key, value] of Object.entries(group)) {
            value.forEach(({ selector, path, args }) => {
                /*
                if the dirname was not specified the main object key will be used as the dirname
                for example:
                 const key = [{ selector: '[data-component-selector]', path: { filename: 'theFileNameOfComponent' }}]; // here the key will be used as the dirname
                 const key = [{ selector: '[data-component-selector]', path: { dirname: 'dirnameOfComponent', filename: 'theFileNameOfComponent' }}]; // here the path.dirname will be used as dirname
                * */
                path.dirname ?? (path.dirname = key);
                importChunk({
                    selector,
                    path,
                    chunk,
                    args,
                });
            });
        }
    });
};

export { chunkMapLoop };
